import { render } from "./FileStorageSchemaImporter.vue?vue&type=template&id=381ef3b1"
import script from "./FileStorageSchemaImporter.vue?vue&type=script&lang=js"
export * from "./FileStorageSchemaImporter.vue?vue&type=script&lang=js"

import "./FileStorageSchemaImporter.vue?vue&type=style&index=0&id=381ef3b1&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__